import { useMutationUpdateScheduledVersion } from '@ben/columbia/hooks/use-mutation-update-scheduled-version';
import { useInvalidateScheduledVersion } from '@ben/columbia/hooks/use-query-scheduled-version';
import Button, { ButtonVariant } from '@ben/orion/deprecated-button';
import type { IModularBenefitDetail } from '@ben/shared/types/columbia';
import { useState } from 'react';
import { toast } from 'react-toastify';
import RenewalWindowModal from '../renewal-window-modal';
import { sanitizePayload } from '../utils';

interface EditRenewalDateButtonProps {
  benefit: IModularBenefitDetail;
  benefitId?: string;
  versionId?: string;
}

const EditRenewalDateButton = ({
  benefit,
  benefitId,
  versionId,
}: EditRenewalDateButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const invalidateScheduledVersion = useInvalidateScheduledVersion();

  const { mutate: updateScheduledVersion, isLoading } =
    useMutationUpdateScheduledVersion({
      onSuccess: () => {
        void invalidateScheduledVersion(benefitId);
        toast.success('Renewal date updated');
        setIsModalOpen(false);
      },
      onError: () => {
        toast.error('Error updating renewal date');
      },
    });

  return (
    <>
      <Button
        label="Edit renewal date"
        variant={ButtonVariant.secondary}
        onClick={() => setIsModalOpen(true)}
        width="auto"
      />
      <RenewalWindowModal
        title="Edit renewal date and window"
        buttonLabel="Save"
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={(renewalConfig) =>
          updateScheduledVersion({
            benefitId,
            versionId,
            benefit: sanitizePayload(benefit) as IModularBenefitDetail,
            renewalConfig,
          })
        }
        isSubmitting={isLoading}
        initialValues={benefit.renewalConfig}
      />
    </>
  );
};

export default EditRenewalDateButton;
